import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SapError } from 'src/app/lego-utils';
import { map, Observable } from 'rxjs';
import { INotificationNumber } from 'src/app/state/notification-number.model';

@Injectable({
  providedIn: 'root',
})
export class NotificationApiService {
  public constructor(private readonly httpClient: HttpClient) {}

  public getNotificationNumber(designId: string): Observable<INotificationNumber> {
    return this.httpClient.get<INotificationNumber[]>(`api/notification/${designId}`).pipe(
      map((response) => {
        const res = response[0];

        if (!res.notificationNumber) {
          throw new SapError('Could not find notification number. You need to go to SAP for this.');
        }

        return res;
      })
    );
  }
}
